<template>
  <!-- Seção anterior... -->

  <section class="hero-section">
    <div class="hero-content">
      <h1>Inventário Fácil</h1>
      <p class="subtitle">Gestão Inteligente de Estoque em Tempo Real</p>
      
      <div class="app-description">
        <p>
          O <strong>Inventário Fácil</strong> revoluciona o controle de estoque com tecnologia móvel avançada. 
          Desenvolvido para pequenas e médias empresas, oferece:
        </p>
        
        <ul class="key-features">
          <li>• Escaneamento instantâneo de códigos de barras</li>
          <li>• Ajustes em tempo real com histórico completo</li>
          <li>• Exportação em múltiplos formatos (CSV, XML, JSON)</li>
          <li>• Sincronização segura entre dispositivos</li>
          <li>• Interface intuitiva para operação offline</li>
        </ul>

      </div>
</div>
     
  </section>

  <!-- Comparativo de Recursos -->
  <section class="feature-comparison">
    <h2>Vantagens Competitivas</h2>
    <div class="comparison-grid">
      <div class="comparison-card">
        <h3>Inventário Fácil</h3>
        <ul>
          <li v-for="(feature, index) in ourFeatures" :key="index">
            ✓ {{ feature }}
          </li>
        </ul>
      </div>
      <div class="comparison-card competitor">
        <h3>Soluções Tradicionais</h3>
        <ul>
          <li v-for="(feature, index) in competitorFeatures" :key="index">
            ✗ {{ feature }}
          </li>
        </ul>
      </div>
    </div>
  </section>

  <!-- Seção de Perguntas Frequentes -->
  <section class="faq">
    <h2>Perguntas Frequentes</h2>
    <div class="faq-list">
      <div 
        v-for="(item, index) in faqItems" 
        :key="index" 
        class="faq-item"
        @click="toggleFAQ(index)"
      >
        <div class="question">
          {{ item.question }}
          <span class="toggle-icon">{{ activeFAQ === index ? '−' : '+' }}</span>
        </div>
        <transition name="slide-faq">
          <div v-if="activeFAQ === index" class="answer">
            {{ item.answer }}
          </div>
        </transition>
      </div>
    </div>
  </section>

  <div class="privacy-section">
        <button @click="togglePrivacyPolicy" class="toggle-button">
          {{ showPrivacyPolicy ? 'Ocultar' : 'Mostrar' }} Política de Privacidade
          <span class="arrow" :class="{ 'up': showPrivacyPolicy }">▼</span>
        </button>
        
        <transition name="slide">
        <iframe 
                v-if="showPrivacyPolicy"
                :src="privacyPolicyContent"
                class="privacy-iframe"
                frameborder="0"
            ></iframe>
        </transition>
      </div>

</template>

<script>
export default {
  name: 'InventarioFacilPage',
  data() {
    return {
      showPrivacyPolicy: false, // Adicione esta linha
      activeImage: 0,
      activeFAQ: null,
      screenshots: [
        require('@/assets/screenshots/inv0.jpeg'),
        require('@/assets/screenshots/inv1.jpeg'),
        require('@/assets/screenshots/inv3.jpeg'),
        require('@/assets/screenshots/inv4.jpeg'),
        require('@/assets/screenshots/inv5.jpeg')
      ],
      ourFeatures: [
        'Interface simplificada',
        'Escaneamento em tempo real',
        'Exportação multi-formatos',
        'Atualizações gratuitas',
        'Suporte 24/7'
      ],
      competitorFeatures: [
        'Interface complexa',
        'Dependência de hardware',
        'Formato único',
        'Atualizações pagas',
        'Suporte limitado'
      ],
      faqItems: [
        {
          question: 'O aplicativo funciona offline?',
          answer: 'Sim! Você pode escanear produtos e gerenciar seu estoque mesmo sem conexão com a internet.'
        },
        {
          question: 'Quais tipos de código de barras são suportados?',
          answer: 'Suportamos todos os formatos principais: EAN-13, UPC-A, Code 128 e muitos outros.'
        },
        {
          question: 'Como faço para exportar meus dados?',
          answer: 'No menu suspenso, selecione o formato desejado para exportação e envie por e-mail, WhatsApp e outros meios.'
        },
        {
          question: 'Como faço para editar a quantidade de um item?',
          answer: 'No menu suspenso, selecione ver inventário, toque no item desejado e altere a quantidade.'
        },
        {
          question: 'Como faço para excluir um item do inventário?',
          answer: 'Selecione e segure o item que deseja excluir até que apareça a confirmação de exclusão.'
        }
      ],privacyPolicyContent: `data:text/html;charset=utf-8,${encodeURIComponent(`
       <!DOCTYPE html>
<html lang="pt-br">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Política de Privacidade - Inventário Fácil</title>
  <style>
    .privacy-policy {
      font-family: Arial, sans-serif;
      max-width: 800px;
      margin: 0 auto;
      padding: 20px;
      line-height: 1.6;
    }

    h1 { 
      color: #333;
      border-bottom: 2px solid #4CAF50;
      padding-bottom: 10px;
    }
    
    h2 {
      color: #555;
      margin-top: 25px;
    }
    
    p, li {
      color: #666;
    }
    
    a {
      color: #4CAF50;
      text-decoration: none;
    }
  </style>
</head>
<body>
  <div class="privacy-policy">
    <h1>Política de Privacidade do Inventário Fácil</h1>
    <p><em>Última atualização: [Inserir Data]</em></p>

    <h2>1. Informações Coletadas</h2>
    <p>Para o funcionamento do aplicativo, coletamos:</p>
    <ul>
      <li>Dados de inventário inseridos pelo usuário (códigos de barras, descrições de produtos, quantidades)</li>
      <li>Informações técnicas do dispositivo (modelo, sistema operacional, versão do aplicativo)</li>
      <li>Registros de uso das funcionalidades principais</li>
    </ul>

    <h2>2. Uso das Informações</h2>
    <p>Os dados são utilizados exclusivamente para:</p>
    <ul>
      <li>Operação das funcionalidades básicas do aplicativo</li>
      <li>Geração de relatórios e exportação de dados</li>
      <li>Melhoria contínua da experiência do usuário</li>
    </ul>

    <h2>3. Compartilhamento de Dados</h2>
    <p>Seus dados não são compartilhados com terceiros, exceto:</p>
    <ul>
      <li>Nas exportações explicitamente solicitadas pelo usuário (CSV, XML, JSON)</li>
      <li>Quando necessário para cumprir obrigações legais</li>
    </ul>

    <h2>4. Segurança</h2>
    <p>Implementamos medidas de proteção incluindo:</p>
    <ul>
      <li>Criptografia de dados sensíveis</li>
      <li>Armazenamento local seguro</li>
      <li>Atualizações regulares de segurança</li>
    </ul>

    <h2>5. Controle de Dados</h2>
    <p>Os usuários podem:</p>
    <ul>
      <li>Exportar todos os dados através das funcionalidades do aplicativo</li>
      <li>Solicitar exclusão completa dos dados via contato de suporte</li>
    </ul>

    <h2>6. Menores de Idade</h2>
    <p>O aplicativo não coleta intencionalmente dados de menores de 13 anos. O uso por menores deve ser supervisionado por responsáveis legais.</p>

    <h2>7. Alterações na Política</h2>
    <p>Atualizações significativas serão comunicadas através:</p>
    <ul>
      <li>Notificação no aplicativo</li>
      <li>Versão atualizada disponível nesta página</li>
    </ul>

    <h2>8. Contato</h2>
    <p>Para questões sobre privacidade:</p>
    <p>Email: <a href="mailto:aleappdev@gmail.com">aleappdev@gmail.com</a></p>
    

    <p><em>Esta política está em conformidade com a legislação brasileira (LGPD - Lei 13.709/2018)</em></p>
  </div>
</body>
</html>

      `)}`
    }
  },
  methods: {
    nextImage() {
      this.activeImage = (this.activeImage + 1) % this.screenshots.length
    },
    prevImage() {
      this.activeImage = (this.activeImage - 1 + this.screenshots.length) % this.screenshots.length
    },
    toggleFAQ(index) {
      this.activeFAQ = this.activeFAQ === index ? null : index
    },
      togglePrivacyPolicy() {
        this.showPrivacyPolicy = !this.showPrivacyPolicy
      }
  }
}
</script>

<style scoped>
/* Estilos anteriores... */

.screenshots {
  margin: 4rem 0;
}


.control-btn {
  background: rgba(255,255,255,0.8);
  border: none;
  padding: 1rem;
  cursor: pointer;
  font-size: 1.5rem;
  transition: all 0.3s ease;
}

.control-btn:hover {
  background: rgba(255,255,255,1);
}

.feature-comparison {
  background: #f8f9fa;
  padding: 4rem 0;
}

.comparison-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1000px;
  margin: 2rem auto;
}

.comparison-card {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.05);
}

.comparison-card.competitor {
  background: #fff5f5;
}

.comparison-card ul {
  list-style: none;
  padding: 0;
}

.comparison-card li {
  padding: 0.5rem 0;
  border-bottom: 1px solid #eee;
}

.faq {
  padding: 4rem 0;
}

.faq-list {
  max-width: 800px;
  margin: 0 auto;
}

.faq-item {
  background: white;
  margin: 1rem 0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  cursor: pointer;
  transition: all 0.3s ease;
}

.faq-item:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.question {
  padding: 1.5rem;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.toggle-icon {
  font-size: 1.5rem;
  color: #4CAF50;
}

.answer {
  padding: 0 1.5rem 1.5rem;
  color: #666;
  line-height: 1.6;
}

.slide-faq-enter-active,
.slide-faq-leave-active {
  transition: all 0.3s ease;
  max-height: 200px;
  overflow: hidden;
}

.slide-faq-enter-from,
.slide-faq-leave-to {
  opacity: 0;
  max-height: 0;
}

@media (max-width: 768px) {
  .carousel {
    margin: 2rem 1rem;
  }
  
  .comparison-grid {
    grid-template-columns: 1fr;
  }
  
  .faq-item {
    margin: 1rem;
  }
}

.privacy-section {
    margin-top: 30px;
    border-top: 1px solid #eee;
    padding-top: 20px;
  }
  
  .toggle-button {
    background: #4CAF50;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background 0.3s;
  }
  
  .toggle-button:hover {
    background: #45a049;
  }
  
  .arrow {
    display: inline-block;
    transition: transform 0.3s;
    margin-left: 10px;
  }
  
  .arrow.up {
    transform: rotate(180deg);
  }
  
  .privacy-iframe {
    width: 100%;
    height: 500px;
    margin-top: 15px;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .slide-enter-active, .slide-leave-active {
    transition: all 0.5s ease;
    max-height: 600px;
    overflow: hidden;
  }
  
  .slide-enter-from, .slide-leave-to {
    max-height: 0;
    opacity: 0;
  }

  .carousel {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 15px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.carousel-item {
  display: none;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  max-height: 70vh;
  aspect-ratio: 16/9;
  margin: 0 auto;
}

.carousel-item.active {
  display: flex;
}

.carousel-image {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
  transition: transform 0.3s ease;
}

.carousel-controls {
  /* Mantenha os controles posicionados corretamente */
}

/* Responsividade */
@media (max-width: 768px) {
  .carousel-item {
    max-height: 50vh;
    aspect-ratio: 9/16;
  }
  
  .carousel-image {
    max-height: 50vh;
  }
}


/* Hero Section */
.hero-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
  padding: 4rem 0;
}

.hero-content h1 {
  font-size: 2.8rem;
  color: #1B5E20;
  line-height: 1.2;
  margin-bottom: 1.5rem;
}

.subtitle {
  font-size: 1.8rem;
  color: #388E3C;
  font-weight: 500;
  margin-bottom: 1.2rem;
}

.hero-description {
  font-size: 1.1rem;
  color: #424242;
  line-height: 1.8;
  margin-bottom: 2rem;
}

.hero-image {
  max-width: 100%;
  height: auto;
  border-radius: 15px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}


</style>